import {
  Layout,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import { Requests } from "../features/Requests";
import { DragDropContext, DropResult } from "@hello-pangea/dnd";
import {
  setDate,
  setDraggableId,
} from "../../infrastructure/redux/PlanningSlice";
import { Outlet } from "react-router-dom";
import { usePlanningUpdateCheckerHook } from "../../infrastructure/hooks/usePlanningUpdateCheckerHook";
import { Routes } from "../features/Routes";
import { planningDragEnd } from "../../infrastructure/redux/thunks/planningDragEndThunk";
import { getPlanningRoutes } from "../../infrastructure/redux/thunks/route/getPlanningRoutesThunk";
import { DefinitiveButton } from "../features/DefinitiveButton";
import { usePollingHook } from "../../../../event/infrastructure/usePollingHook";

export const DailyPlanningPage = () => {
  const { t } = useTranslation("common");
  const dispatch = useAppDispatch();

  const title = t("Planning");

  const { date } = useAppSelector((state) => state.planning);

  const dragEnd = (result: DropResult) => {
    dispatch(setDraggableId(null));
    void dispatch(planningDragEnd(result));
  };

  usePollingHook();

  usePlanningUpdateCheckerHook();

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title}>
            <Form.Group className={"ms-3"}>
              <Form.Control
                type="date"
                value={date}
                onChange={(e) => {
                  dispatch(setDate(e.target.value));
                  void dispatch(getPlanningRoutes(e.target.value));
                }}
              />
            </Form.Group>
          </LayoutHeaderTitle>

          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>

          <LayoutHeaderActions>
            <div className="d-flex gap-2">
              <DefinitiveButton />
            </div>
          </LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <div className={"container-fluid p-4"}>
        <DragDropContext
          onDragEnd={dragEnd}
          onDragStart={(start) => dispatch(setDraggableId(start.draggableId))}
        >
          <Routes />
          <Requests />
        </DragDropContext>
        <Outlet />
      </div>
    </Layout>
  );
};
